import React, { useEffect, useState } from "react";
import {
    FaUser,
} from "react-icons/fa";
import tw from "tailwind-styled-components";
import { MdOutlineChevronRight } from "react-icons/md";

function SummaryCards({ summaryData, attendanceFlag, onClick }) {
    const [selectedId, setSelectedId] = useState(null);
    const currentLeadData = [
        {
            amount: summaryData?.total,
            label: "Total Staffs",
            color: "text-black",
            icon: <FaUser className="text-black" />,
            filter: 'T',
        },
        {
            amount: attendanceFlag === '1' ? summaryData?.present : 0,
            label: "Present",
            color: "text-black",
            icon: <FaUser className="text-black" />,
            filter: 'N',
        },
        {
            amount: attendanceFlag === '1' ? summaryData?.absent : 0,
            label: "Absent",
            color: "text-black",
            icon: <FaUser className="text-black" />,
            filter: 'FU',
        },
    ];

    return (
        <Wrapper>

            <ScrollCard
                style={{
                    scrollBehavior: "smooth",
                }}
            >
                {currentLeadData.map((item, index) => (
                    <Card selectedId={selectedId} index={index} key={index} onClick={() => {
                        setSelectedId(index);
                        onClick(item.filter);
                    }
                    }>
                        <div className="h-16">
                            <Value color={item.color}>{item.amount}</Value>
                            <Label>
                                {item.label}
                                <MdOutlineChevronRight className="text-gray-300" size={24} />
                            </Label>
                        </div>
                    </Card>
                    // <Card key={index} onClick={() => onClick(item.filter)}>
                    //     <div >
                    //         <span className={`text-lg font-bold ${item.color}`}>
                    //             {item.amount}
                    //         </span>
                    //         <Label>

                    //             {item.label}

                    //             {item.icon}
                    //         </Label>
                    //     </div>
                    // </Card>
                ))}
            </ScrollCard>
        </Wrapper>
    );
}
const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto  flex space-x-4 py-1`;
const Card = tw.div`min-w-[200px] p-3 rounded-md bg-white shadow-md cursor-pointer hover:shadow-sm hover:shadow-primary-color  ${({ selectedId, index }) => selectedId === index ? "shadow-sm shadow-primary-color" : ""}`;
const Label = tw.div`text-gray-500 text-sm break-words flex items-center w-full mt-2 justify-between break-words whitespace-normal w-full`;
const Value = tw.p`
  text-xl sm:text-2xl font-bold  
  ${({ color }) =>
        color}
`;

export default SummaryCards;

